import { ENROLL_ALERT } from '../const/analytics';
var buttonAnalytics = function (formData) {
    if (formData.attributes !== null) {
        var _a = formData.attributes, reminderDueDays = _a.reminderDueDays, promoExpiryDays = _a.promoExpiryDays, balanceExceedsThresholdAmount = _a.balanceExceedsThresholdAmount, availableCreditThresholdAmount = _a.availableCreditThresholdAmount;
        if (reminderDueDays) {
            return "".concat(ENROLL_ALERT.DAYS, ":").concat(reminderDueDays.value);
        }
        if (promoExpiryDays) {
            return "".concat(ENROLL_ALERT.DAYS, ":").concat(promoExpiryDays.value);
        }
        if (balanceExceedsThresholdAmount) {
            return "".concat(ENROLL_ALERT.AMOUNT, ":").concat(balanceExceedsThresholdAmount.value);
        }
        if (availableCreditThresholdAmount) {
            return "".concat(ENROLL_ALERT.AMOUNT, ":").concat(availableCreditThresholdAmount.value);
        }
    }
    return '';
};
export default buttonAnalytics;
